<ng-container *transloco="let convert;">
  @if (isVisible) {
    <div>
      <header>
        <h3 class="text-brand fw-normal" tabindex="-1" #heading>
          {{convert('sellModule.offers.revive.textReviveOffer')}}
        </h3>
      </header>
      <div id="disclosures">
        <p [innerHTML]="convert('sellModule.offers.revive.textSelectingRevive', {title : title})"></p>
      </div>
      <div class="mb-4">
        <app-datalist-item
          class="mb-4"
          label="{{convert('sellModule.offers.common.labelBuyerOffer')}}"
          [value]="get('amount', false) ? formatCurrency(get('amount', false)) : 'N/A'"
        ></app-datalist-item>
      </div>
      <div class="mb-4">
        <app-datalist-item class="mb-4" label="{{convert('sellModule.offers.revive.labelSellerComment')}}" [value]="offer.comment || 'N/A'"></app-datalist-item>
      </div>
      <form [formGroup]="reviveForm">
        <div class="d-flex flex-column app-textarea">
          <div class="form-group mb-0">
            <label class="d-block text-start" for="revive-offer-comment">{{convert('sellModule.offers.common.labelComment')}}</label>
            <textarea
              id="revive-offer-comment"
              class="form-control mb-1"
              rows="3"
              maxlength="150"
              formControlName="offerComment"
              appCharacterCount
              #comment="appCharacterCount"
              (keyup)="replaceInvalidCharacters($event)"
            ></textarea>
            <app-character-count
              [count]="comment.count$ | async"
              [maxLength]="150"
              [characterCountTranslate]="characterCountData">
            </app-character-count>
          </div>
        </div>
        <div class="d-lg-flex mb-0">
          <div class="form-group" [class.reviveForm]="localErrorMessage">
            <label class="d-block text-start"
            for="revive-offer-amount">{{convert('sellModule.offers.revive.labelReviveOffer')}}</label>
            <div class="input-wrapper">
              <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
              @if (!isFrenchCanadian) {
                <input
                  id="revive-offer-amount"
                  mask="separator.0"
                  thousandSeparator=","
                  class="form-control american-input"
                  [ngModel]="offer.amount"
                  name="reviveOfferAmount"
                  required
                  formControlName="reviveOfferAmount"
                  aria-labelledBy="revive-offer-amount-label revive-offer-amount-error"
                  (keyup)="setReviveAmountAndClearFormErrors()"
                  separatorLimit="111111"
                  [class.invalid-input]="localErrorMessage" />
              }
              @if (isFrenchCanadian) {
                <input
                  id="revive-offer-amount"
                  class="form-control canadian-input"
                  [ngModel]="offer.amount"
                  name="reviveOfferAmount"
                  required
                  formControlName="reviveOfferAmount"
                  aria-labelledBy="revive-offer-amount-label revive-offer-amount-error"
                  (keyup)="setReviveAmountAndClearFormErrors()"
                  [class.invalid-input]="localErrorMessage"
                  mask="separator.0"
                  thousandSeparator=" "
                  decimalMarker=","
                  separatorLimit="111111"
                  />
              }
            </div>
          </div>
        </div>
      </form>
      <div class="error-message" aria-live="polite" tabindex="-1">
        @if (localErrorMessage) {
          <strong>{{localErrorMessage}}<br /></strong>
        }
      </div>
      <div class="d-flex flex-column flex-lg-row lg-justify-content-start gap-3">
        <button
          class="btn btn-primary"
          type="submit"
          data-track-elem="button"
          [attr.data-track-name]="'Revive-' + inventoryItem.inventoryItemUuid"
          data-track-trigger="offer"
          [attr.data-track-region]="offer.dealershipName"
          [attr.data-track-id]="inventoryItem.inventoryItemUuid"
          (click)="revive()"
          >
          {{convert('sellModule.offers.revive.btnRevive')}}
        </button>
        <button
          class="ms-lg-2 mt-2 mt-lg-0 btn btn-link"
          type="button"
          data-track-elem="button"
          data-track-name="Cancel"
          data-track-trigger="close"
          (click)="cancel.emit()"
          >
          <span>{{convert('common.btnCancel')}}</span>
        </button>
      </div>
    </div>
  }
</ng-container>
